import { PremiumDomainConnectSecondStep } from '../lazyFunctions';
import { showModal } from 'owa-modal';

export function launchDomainConnectSetAlias(domain: string, csrfToken: string): void {
    mountDomainConnectSecondStep(domain, csrfToken);
}

function noop() {}

function mountDomainConnectSecondStep(domain: string, csrfToken: string) {
    const WrappedComponent = () => (
        <PremiumDomainConnectSecondStep
            domainName={domain}
            csrfToken={csrfToken}
            mountFromDomainDashBoard={false}
            isSecondaryUser={false}
            onClose={noop}
        />
    );
    showModal(WrappedComponent);
}
